export default __webpack_public_path__ + "static/media/agile-polly-add-tab.926b9821.svg";